export const initialNodes = [
    {
        id: 'email-1',
        type: 'emailSent',
        position: { x: 250, y: 0 },
        draggable: false,
    },
    {
        id: 'wait-1',
        type: 'wait',
        position: { x: 250, y: 200 },
        data: { days: 3 },
        draggable: false,
    },
    {
        id: 'check-1',
        type: 'checkEmail',
        position: { x: 250, y: 400 },
        draggable: false,
    },
    {
        id: 'followup-1',
        type: 'followUp',
        position: { x: 250, y: 600 },
        draggable: false,
    },
];

export const initialEdges = [
    { id: 'e1-2', source: 'email-1', target: 'wait-1' },
    { id: 'e2-3', source: 'wait-1', target: 'check-1' },
    { id: 'e3-4', source: 'check-1', target: 'followup-1', sourceHandle: 'no' },
];